import { XLogoIcon } from '@phosphor-icons/react';

import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const XIcon = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return <XLogoIcon size={Sizes[size]} color={fill || stroke} {...rest} />;
};

XIcon.displayName = 'XIcon';
